import React, { useEffect, useState } from 'react';
import { usersService } from '../services/api';
import { Plus, Loader, X, Check, User, Edit, Trash2, Lock, Unlock } from 'lucide-react';
import { usePermissions } from '../hooks/usePermissions';
import { PermissionGuard } from '../components/PermissionGuard';
import { PERMISSIONS } from '../utils/permissions';
const Utilisateurs = () => {
  const { hasPermission } = usePermissions();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

const itemsPerPage = 20;
const [totalItems, setTotalItems] = useState(0);

  const [currentPage, setCurrentPage] = useState(1);


  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    full_name: '',
    phone: '',
    role: 'operateur'
  });
  const [editFormData, setEditFormData] = useState({
    email: '',
    full_name: '',
    phone: '',
    password: '',
    role: 'operateur',
    is_active: true
  });

  useEffect(() => {
    fetchUsers();
  }, [currentPage]);

  // const fetchUsers = async () => {
  //   try {
  //     const response = await usersService.getAll();
  //     setUsers(response.data);
  //   } catch (error) {
  //     console.error('Erreur:', error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchUsers = async () => {
  try {
    setLoading(true);

    const response = await usersService.getAll({
      skip: (currentPage - 1) * itemsPerPage,
      limit: itemsPerPage,
    });

    setUsers(response.data.items);
    setTotalItems(response.data.total);
  } catch (error) {
    console.error('Erreur:', error);
  } finally {
    setLoading(false);
  }
};



  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await usersService.create(formData);
      setShowModal(false);
      resetForm();
      fetchUsers();
      alert('Utilisateur créé avec succès!');
    } catch (error) {
      alert(error.response?.data?.detail || 'Erreur lors de la création');
    } finally {
      setLoading(false);
    }
  };

  

  const handleEdit = (user) => {
    setSelectedUser(user);
    setEditFormData({
      email: user.email || '',
      full_name: user.full_name || '',
      phone: user.phone || '',
      password: '', // ✅ toujours vide : on ne connaît pas (et on n'affiche jamais) l'ancien mot de passe
      role: user.role,
      is_active: user.is_active
    });
    setShowEditModal(true);
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Mot de passe : envoyé seulement s'il a été saisi
    const payload = { ...editFormData };
    if (!payload.password || !payload.password.trim()) delete payload.password;
    else if (payload.password.trim().length < 6) {
      alert('Le mot de passe doit contenir au moins 6 caractères');
      setLoading(false);
      return;
    }

    try {
      const res = await usersService.update(selectedUser.id, payload);
      setShowEditModal(false);
      setSelectedUser(null);
      fetchUsers();
      alert(res?.data?.password_changed
        ? 'Utilisateur modifié et mot de passe changé avec succès !'
        : 'Utilisateur modifié avec succès !');
    } catch (error) {
      alert(error.response?.data?.detail || 'Erreur lors de la modification');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (userId, username) => {
    if (window.confirm(`Êtes-vous sûr de vouloir supprimer l'utilisateur "${username}" ?`)) {
      try {
        const res = await usersService.delete(userId);
        fetchUsers();
        alert(res?.data?.message || 'Utilisateur supprimé avec succès !');
      } catch (error) {
        alert(error.response?.data?.detail || 'Erreur lors de la suppression');
      }
    }
  };

  const handleToggleActive = async (userId, username, isActive) => {
    const action = isActive ? 'désactiver' : 'activer';
    if (window.confirm(`Êtes-vous sûr de vouloir ${action} l'utilisateur "${username}" ?`)) {
      try {
        await usersService.toggleActive(userId);
        fetchUsers();
        alert(`Utilisateur ${isActive ? 'désactivé' : 'activé'} avec succès!`);
      } catch (error) {
        alert(error.response?.data?.detail || `Erreur lors de l'opération`);
      }
    }
  };

  const resetForm = () => {
    setFormData({
      username: '',
      email: '',
      password: '',
      full_name: '',
      phone: '',
      role: 'operateur'
    });
  };

  const getRoleBadge = (role) => {
    const badges = {
      administrateur: 'bg-purple-100 text-purple-700',
      gestionnaire: 'bg-blue-100 text-blue-700',
      operateur: 'bg-green-100 text-green-700',
      lecture: 'bg-gray-100 text-gray-700'
    };
    return badges[role] || badges.operateur;
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Gestion des Utilisateurs</h1>
          <p className="text-gray-600 text-sm mt-1">Liste de tous les utilisateurs du système</p>
        </div>
        <button
          onClick={() => { resetForm(); setShowModal(true); }}
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center gap-2 shadow-sm"
        >
          <Plus size={20} />
          Nouvel Utilisateur
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        {loading ? (
          <div className="flex items-center justify-center py-12">
            <Loader className="w-8 h-8 animate-spin text-blue-600" />
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50 border-b border-gray-200">
                <tr>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Utilisateur</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Email</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Téléphone</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Rôle</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Statut</th>
                  <th className="text-left py-3 px-4 text-sm font-semibold text-gray-700">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {users.map((user) => (
                  <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                    <td className="py-3 px-4">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                          <User className="w-5 h-5 text-blue-600" />
                        </div>
                        <div>
                          <p className="text-sm font-semibold text-gray-900">{user.full_name || user.username}</p>
                          <p className="text-xs text-gray-500">@{user.username}</p>
                        </div>
                      </div>
                    </td>
                    <td className="py-3 px-4 text-sm text-gray-700">{user.email}</td>
                    <td className="py-3 px-4 text-sm text-gray-700">{user.phone || '-'}</td>
                    <td className="py-3 px-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium capitalize ${getRoleBadge(user.role)}`}>
                        {user.role}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                        user.is_active
                          ? 'bg-green-100 text-green-700'
                          : 'bg-red-100 text-red-700'
                      }`}>
                        {user.is_active ? 'Actif' : 'Inactif'}
                      </span>
                    </td>
                    <td className="py-3 px-4">
                      <div className="flex items-center gap-2">
                        <PermissionGuard permission={PERMISSIONS.EDIT_USER}>
                        <button
                          onClick={() => handleEdit(user)}
                          className="p-1.5 text-blue-600 hover:bg-blue-50 rounded transition-colors"
                          title="Modifier"
                        >
                          <Edit size={18} />
                        </button>
                        </PermissionGuard>
                        <PermissionGuard permission={PERMISSIONS.BLOCK_USER}>
                        <button
                          onClick={() => handleToggleActive(user.id, user.username, user.is_active)}
                          className={`p-1.5 rounded transition-colors ${
                            user.is_active 
                              ? 'text-orange-600 hover:bg-orange-50' 
                              : 'text-green-600 hover:bg-green-50'
                          }`}
                          title={user.is_active ? 'Bloquer' : 'Activer'}
                        > 
                          {user.is_active ? <Lock size={18} /> : <Unlock size={18} />}
                        </button>
                        </PermissionGuard>
                        <PermissionGuard permission={PERMISSIONS.DELETE_USER}>
                        <button
                          onClick={() => handleDelete(user.id, user.username)}
                          className="p-1.5 text-red-600 hover:bg-red-50 rounded transition-colors"
                          title="Supprimer"
                        >
                          <Trash2 size={18} />
                        </button>
                        </PermissionGuard>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        {totalItems > 0 && (
  <div className="flex justify-between items-center p-4">
    <span className="text-sm text-gray-600">
      {(currentPage - 1) * itemsPerPage + 1}
      {' - '}
      {Math.min(currentPage * itemsPerPage, totalItems)}
      {' / '}
      {totalItems}
    </span>

    <div className="flex gap-2">
      <button
        onClick={() => setCurrentPage(p => Math.max(p - 1, 1))}
        disabled={currentPage === 1}
        className="px-3 py-1 border rounded"
      >
        Précédent
      </button>

      <span className="px-3 py-1">
        {currentPage} / {Math.ceil(totalItems / itemsPerPage)}
      </span>

      <button
        onClick={() =>
          setCurrentPage(p =>
            p < Math.ceil(totalItems / itemsPerPage) ? p + 1 : p
          )
        }
        disabled={currentPage >= Math.ceil(totalItems / itemsPerPage)}
        className="px-3 py-1 border rounded"
      >
        Suivant
      </button>
    </div>
  </div>
)}

      </div>

      {/* Modal Création */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900">Nouvel Utilisateur</h2>
              <PermissionGuard permission={PERMISSIONS.ADD_USER}>
              <button onClick={() => setShowModal(false)} className="text-gray-400 hover:text-gray-600">
                <X size={24} />
              </button>
              </PermissionGuard>
            </div>

            <form onSubmit={handleSubmit} className="p-6 space-y-4" autoComplete="off">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nom d'utilisateur *</label>
                <input
                  type="text"
                  name="new-user-username"
                  autoComplete="off"
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  name="new-user-email"
                  autoComplete="off"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Mot de passe *</label>
                <input
                  type="password"
                  name="new-user-password"
                  autoComplete="new-password"
                  value={formData.password}
                  onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nom complet</label>
                <input
                  type="text"
                  value={formData.full_name}
                  onChange={(e) => setFormData({ ...formData, full_name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Téléphone</label>
                <input
                  type="tel"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Rôle *</label>
                <select
                  value={formData.role}
                  onChange={(e) => setFormData({ ...formData, role: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="operateur">Opérateur</option>
                  <option value="gestionnaire">Gestionnaire</option>
                  <option value="administrateur">Administrateur</option>
                  <option value="lecture">Lecture seule</option>
                </select>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {loading ? <Loader className="w-5 h-5 animate-spin" /> : <Check size={20} />}
                  Créer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal Modification */}
      {showEditModal && selectedUser && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900">Modifier l'Utilisateur</h2>
              
              <button onClick={() => setShowEditModal(false)} className="text-gray-400 hover:text-gray-600">
                <X size={24} />
              </button>
            </div>

            <form onSubmit={handleUpdateSubmit} className="p-6 space-y-4" autoComplete="off">
              <p className="text-sm text-gray-500">
                Utilisateur : <span className="font-semibold text-gray-800">@{selectedUser.username}</span>
              </p>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Email *</label>
                <input
                  type="email"
                  name="edit-user-email"
                  autoComplete="off"
                  value={editFormData.email}
                  onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nom complet</label>
                <input
                  type="text"
                  value={editFormData.full_name}
                  onChange={(e) => setEditFormData({ ...editFormData, full_name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Téléphone</label>
                <input
                  type="tel"
                  value={editFormData.phone}
                  onChange={(e) => setEditFormData({ ...editFormData, phone: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nouveau mot de passe</label>
                <input
                  type="password"
                  name="edit-user-new-password"
                  autoComplete="new-password"
                  value={editFormData.password}
                  onChange={(e) => setEditFormData({ ...editFormData, password: e.target.value })}
                  placeholder="Laisser vide pour ne pas changer"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <p className="text-xs text-gray-500 mt-1">Minimum 6 caractères. Vide = mot de passe inchangé.</p>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Rôle *</label>
                <select
                  value={editFormData.role}
                  onChange={(e) => setEditFormData({ ...editFormData, role: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="operateur">Opérateur</option>
                  <option value="gestionnaire">Gestionnaire</option>
                  <option value="administrateur">Administrateur</option>
                  <option value="lecture">Lecture seule</option>
                </select>
              </div>

              <div>
                <label className="flex items-center gap-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={editFormData.is_active}
                    onChange={(e) => setEditFormData({ ...editFormData, is_active: e.target.checked })}
                    className="w-4 h-4 text-blue-600 rounded focus:ring-2 focus:ring-blue-500"
                  />
                  <span className="text-sm font-medium text-gray-700">Utilisateur actif</span>
                </label>
              </div>

              <div className="flex gap-3 pt-4">
                <button
                  type="button"
                  onClick={() => setShowEditModal(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
                >
                  Annuler
                </button>
                <button
                  type="submit"
                  disabled={loading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 flex items-center justify-center gap-2"
                >
                  {loading ? <Loader className="w-5 h-5 animate-spin" /> : <Check size={20} />}
                  Modifier
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Utilisateurs;